import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Disable the full-screen error overlay
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error; // Save the original console.error function
  console.error = (...args) => {
    // Suppress React's full-screen error overlay
    if (args[0] && typeof args[0] === 'string' && args[0].includes('Error:')) {
      return; // Ignore errors that trigger the overlay
    }
    originalConsoleError(...args); // Log other errors as usual
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
